import { jwtDecode } from "jwt-decode";
import { getStoredAuthToken } from "../../utils/authSession";

export const AIPO_PREVIEW_CLIENT_ID = 87;

export const getAipoIdentity = () => {
  try {
    const storedToken = getStoredAuthToken();
    if (!storedToken) return null;
    const token = storedToken.startsWith("Bearer ") ? storedToken.slice(7) : storedToken;
    const claims = jwtDecode(token);
    return {
      clientId: Number(
        claims?.id_clienteAipim ??
          claims?.id_cliente ??
          claims?.idCliente ??
          claims?.cliente_id
      ),
      name: claims?.nome || claims?.name || "Usuário",
      email: claims?.email || claims?.sub || "",
      company: claims?.nomeCliente || claims?.nome_cliente || claims?.cliente || "",
    };
  } catch {
    return null;
  }
};

export const canAccessAipoPreview = () =>
  getAipoIdentity()?.clientId === AIPO_PREVIEW_CLIENT_ID;
